import "./header";
import "./cart";
import { carouselInit } from "./carousel";
import CreateCustomSelect from "./custom-select";
import {
	ShowElement,
	HideElement,
	ToggleElement,
	RemoveAutoFill,
	cleanHotelCardStyles,
} from "./utils";
import { deffer_images } from "./img-defer";
import Search from "./search";
import PopupForm from "./popupForm";

window.addEventListener("load", () => {
	// smoothscroll.polyfill();
	document.querySelector("html").style = "margin-top: 0px !important";
	deffer_images({});

	new CreateCustomSelect("#pre-footer-advisor-picker");

	if(location.pathname == '/pitajte-savetnika/' || location.pathname == '/posaljite-upit/' ){
		
		const forma = document.querySelector('.wpcf7-form');
			
		document.addEventListener( 'wpcf7mailsent', function( event ) {
		// Get form data
	   let name = forma.querySelector("#your-name").value;
	   let surname = forma.querySelector("#your-surname").value;
	   let number = forma.querySelector("#your-phone").value;
	   let email = forma.querySelector("#your-email").value;
	   let advisor = forma.querySelector('#advisor-picker');
	   let selectedOption = advisor.options[advisor.selectedIndex];
	   let selectedAdvisor = selectedOption.textContent;
	   
	   let checkbox = forma.querySelector('.checkbox #advisors');
	   
	   let checked;
	   if(checkbox.checked){
	       console.log('true')
		   checked  = 'true';
	   }else {
	       console.log('false')
		   checked = 'false';
	   }
	   

	   // Store form data in a cookie
	   let date = new Date();
	   date.setTime(date.getTime()+(365*24*60*60*1000));
	   let expires = "; expires="+date.toGMTString();
	   document.cookie = "formData="+name+"&"+surname+"&"+number+"&"+email+"&"+selectedAdvisor+"&"+checked+expires+"; path=/";
	   
	    forma.querySelector("#your-name").setAttribute('value', name);
	   forma.querySelector("#your-surname").setAttribute('value', surname);
	   forma.querySelector("#your-phone").setAttribute('value', number);
	   forma.querySelector("#your-email").setAttribute('value', email);
	   forma.querySelector("#advisor-picker").setAttribute('value', selectedAdvisor);
	   forma.querySelector(".checkbox #advisors").setAttribute('checked','checked' );
	   
	   }, false );
	   
		if (document.cookie.indexOf("formData=") >= 0) {
		
	   // Get the value of the cookie
	   const cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)formData\s*\=\s*([^;]*).*$)|^.*$/, "$1");
	   // Split the value of the cookie into an array
	   const formData = cookieValue.split("&");
	   console.log(formData);
	   // Set the value of the form fields
	  // forma.querySelector("#your-name").value = formData[0];
	  forma.querySelector("#your-name").setAttribute('value', formData[0])
	   forma.querySelector("#your-surname").setAttribute('value', formData[1]);
	   forma.querySelector("#your-phone").setAttribute('value', formData[2])
	   forma.querySelector("#your-email").setAttribute('value', formData[3])
	   let options = forma.querySelector('#advisor-picker').options;

	   
	   if(formData[5] == 'true'){
		  forma.querySelector(".checkbox #advisors").setAttribute('checked','checked' );
	   }
	   
		Array.from(options).forEach(function(option) {
			   if(option.innerText == formData[4]){
				   option.selected = true;
					var event = new Event("change");
					dispatchEvent(event);
			   }
			})
	}
}

	
	document.addEventListener("click", (e) => {
		if (!e.target.closest("[data-open]")) return;
		ShowElement(e.target.closest("[data-open]"));
	});

	document.addEventListener("click", (e) => {
		const openned_modal = document.querySelector(".modal.show");
		if (e.target.closest("[data-close]")) {
			HideElement(e.target.closest("[data-close]"));
		} else if (e.target == openned_modal) {
			HideElement(openned_modal);
		}
	});

	// Init bootstrap carousel if any carousel is present
	carouselInit();

	document.addEventListener("click", (e) => {
		if (!e.target.closest("[data-togle]")) return;
		ToggleElement(e.target.closest("[data-togle]"));
	});

	// if (window.location.href.indexOf("destinacija") > -1){
	// 	let matches = document.body.className.match(/(^|\s)term-(\d+)(\s|$)/);
	// 	let cookie_dest_id = matches[0].split("-")[1];
	// 	document.cookie = `destination_id=${cookie_dest_id}`;
	// 	console.log(cookie_dest_id)
	// }

	// Checking if client is on 'posaljite-upit' page
	// if (window.location.href.indexOf("posaljite-upit") > -1) {
	// 	function getCookie(name) {
	// 		var re = new RegExp(name + "=([^;]+)");
	// 		var value = re.exec(document.cookie);
	// 		return value != null ? unescape(value[1]) : null;
	// 	}
	// 	console.log(getCookie("destination_id"));
	// }

	const menu_bars = document.querySelector(".menu-bars");
	const navbar_container = document.querySelector("#menu-glavna-navigacija");
	const overlay_on_slider = document.querySelector(".overlay-on-slider");
	const mediaQuery_desc = window.matchMedia("(min-width: 992px)");
	const close_button = document.querySelector(
		"#header .left-header .close-menu"
	);

	if (mediaQuery_desc.matches) {
		menu_bars.addEventListener("click", () => {
			if (menu_bars.classList.contains("open")) {
				document.querySelector(".modal--slide-meni").classList.remove("show");
				menu_bars.classList.remove("open");
				navbar_container.classList.remove("visible");
				overlay_on_slider.classList.remove("show");
				close_button.classList.remove("show");
				return;
			}
			document.querySelector(".modal--slide-meni").classList.add("show");
			overlay_on_slider.classList.add("show");

			if (
				document.querySelector(".modal--slide-meni").classList.contains("show")
			) {
				navbar_container.classList.add("visible");
			}
			menu_bars.classList.add("open");
			close_button.classList.add("show");
		});

		document.body.addEventListener("click", (e) => {
			if (
				e.target.closest("#menu-glavna-navigacija") ||
				e.target.closest(".menu-bars")
			)
				return;
			//klasa na ceo html dokument

			navbar_container.classList.remove("visible");
			document.querySelector(".modal--slide-meni").classList.remove("show");
			overlay_on_slider.classList.remove("show");
			menu_bars.classList.remove("open");
			close_button.classList.remove("show");
		});
	}

	//Mobile header

	const mediaQuery_mobile = window.matchMedia("(max-width: 991px)");
	const mobile_header = document.querySelector("#header .mobile-modal");
	const mobile_header_wrapper = document.querySelector(
		"#header .mobile-modal .mobile-header"
	);

	let dropdown_arrows = document.querySelectorAll(
		".mobile-header .menu-item-has-children"
	);

	const sub_menu_open = document.querySelectorAll(
		"#header .mobile-modal .menu-item-has-children .mega-menu .mega-sub-menu"
	);

	for (let i = 0; i < dropdown_arrows.length; i++) {
		let after_el = document.createElement("div");
		after_el.classList.add("arrow");
		after_el.innerHTML = ">";

		dropdown_arrows[i].appendChild(after_el);
	}

	let dropdowns = document.querySelectorAll(
		"#header .menu-item-has-children .arrow"
	);

	if (mediaQuery_mobile.matches) {
		menu_bars.addEventListener("click", () => {
			if (menu_bars.classList.contains("open")) {
				menu_bars.classList.remove("open");
				return;
			}

			const navbar = document.querySelector(".mobile-header .navbar-nav");
			const search_bar = document.querySelector(
				"#search-wrapper .input-wrapper"
			);

			dropdowns.forEach((key) => {
				key.addEventListener("click", () => {
					document.querySelector(".logo").style.opacity = "0";

					search_bar.style.display = "none";

					const mega_menu_open = key.parentElement.querySelector(".mega-menu");
					mega_menu_open.parentElement.parentElement.style.visibility =
						"hidden";
					mega_menu_open.style.visibility = "visible";
					mega_menu_open.classList.add("open");
					const menu_title = document.createElement("div");
					menu_title.classList.add("menu-title");
					mobile_header_wrapper.appendChild(menu_title);

					const menu_arrow = document.createElement("a");
					menu_arrow.classList.add("back-arrow");

					mobile_header_wrapper.appendChild(menu_arrow);

					function backArrow() {
						setTimeout(() => {
							menu_arrow.innerHTML = "<";
						}, 80);

						menu_arrow.addEventListener("click", () => {
							document.querySelector(".logo").style.opacity = "1";
							search_bar.style.display = "block";
							mega_menu_open.parentElement.parentElement.style.visibility =
								"visible";
							menu_arrow.innerHTML = "";
							menu_title.innerHTML = "";

							mega_menu_open.classList.remove("open");
						});
					}
					backArrow();

					function menuTitle() {
						setTimeout(() => {
							menu_title.innerHTML =
								key.previousElementSibling.previousElementSibling.textContent;
						}, 80);
					}
					menuTitle();

					if (mega_menu_open.classList.contains("open")) {
						const dropdown_link = mega_menu_open.querySelectorAll(".arrow");
						dropdown_link.forEach((el) => {
							el.addEventListener("click", () => {
								const mega_menu_row =
									mega_menu_open.querySelector(".mega-menu__row");
								mega_menu_row.style.visibility = "hidden";
								mega_menu_row
									.querySelector(".mega-sub-menu")
									.classList.add("open");
								el.previousElementSibling.style = "visibility: visible;";
								el.previousElementSibling.classList.remove("close");

								function backArrow() {
									setTimeout(() => {
										menu_title.innerHTML = key.textContent;

										menu_arrow.addEventListener("click", () => {
											menu_arrow.innerHTML = "<";
											navbar.style.visibility = "hidden";
											mega_menu_open.classList.add("open");
											el.previousElementSibling.style.visibility = "hidden";
											mega_menu_row.style.visibility = "visible";
											menu_title.innerHTML =
												key.previousElementSibling.previousElementSibling.textContent;
											document.querySelector(".logo").style.opacity = "0";
											search_bar.style.display = "none";

											if (mega_menu_open.classList.contains("open")) {
												menu_arrow.addEventListener("click", () => {
													mega_menu_open.classList.remove("open");
													menu_title.innerHTML = "";
													navbar.style.visibility = "visible";
													menu_arrow.innerHTML = "";
													document.querySelector(".logo").style.opacity = "1";
													search_bar.style.display = "block";
												});
											}
										});
									}, 80);
								}
								backArrow();

								function menuTitle() {
									setTimeout(() => {
										menu_title.innerHTML =
											el.previousElementSibling.previousElementSibling.textContent;
									}, 80);
								}
								menuTitle();

								const sub_menu_arrow = mega_menu_row.querySelectorAll(
									".mega-sub-menu .arrow"
								);
								if (sub_menu_arrow) {
									sub_menu_arrow.forEach((elem) => {
										elem.addEventListener("click", () => {
											elem.parentElement.parentElement.style.visibility =
												"hidden";
											elem.closest(".mega-menu").style =
												"overflow-y: unset; visibility:visible";

											function backArrow() {
												setTimeout(() => {
													menu_title.innerHTML =
														elem.previousElementSibling.previousElementSibling.textContent;
													menu_arrow.addEventListener("click", () => {
														mega_menu_row.style.visibility = "hidden";
														elem.previousElementSibling.style.visibility =
															"hidden";
														mega_menu_open.style =
															"overflow-y: scroll; visibility:visible";

														menu_title.innerHTML =
															el.previousElementSibling.previousElementSibling.textContent;
														elem.parentElement.parentElement.style =
															"visibility:visible;";

														if (mega_menu_open.classList.contains("open")) {
															menu_arrow.addEventListener("click", () => {
																search_bar.style.display = "none";
																mega_menu_open.classList.add("open");
																mega_menu_row.style.visibility = "visible";
																elem.parentElement.parentElement.style.visibility =
																	"hidden";
																navbar.style.visibility = "hidden";
																menu_title.innerHTML =
																	key.previousElementSibling.previousElementSibling.textContent;

																menu_arrow.innerHTML = "<";
																document.querySelector(".logo").style.opacity =
																	"0";

																menu_arrow.addEventListener("click", () => {
																	if (
																		mega_menu_open.classList.contains("open")
																	) {
																		mega_menu_open.classList.remove("open");
																		navbar.style.visibility = "visible";
																		search_bar.style.display = "block";
																		menu_title.innerHTML = "";
																		menu_arrow.innerHTML = "";
																		document.querySelector(
																			".logo"
																		).style.opacity = "1";
																	}
																});
															});
														}
													});
												}, 80);
											}
											backArrow();
										});
									});
								}
							});
						});
					}

					sub_menu_open.forEach((el) => {
						el.classList.add("close");
					});
				});
			});
			menu_bars.classList.add("open");
		});

		//Otvaranje i zatvaranje modala klikom na burger

		menu_bars.addEventListener("click", () => {
			mobile_header.classList.toggle("show");
			document.body.classList.toggle("overflow");
		});

		document.body.addEventListener("click", (e) => {
			if (
				e.target.closest("#menu-glavna-navigacija") ||
				e.target.closest(".menu-bars")
			)
				return;

			menu_bars.classList.remove("open");
			close_button.classList.remove("show");
		});

		//zatvaranje modala na X dugme

		close_button.addEventListener("click", () => {
			mobile_header.classList.remove("show");
			menu_bars.classList.remove("open");
		});
	}

	const ask_group_box_title = document.querySelector(
		".ask-group .main-subtitle"
	);

	const ask_group = document.querySelector(".ask-group");

	//Funkcija za dropdown ask box u hero sekciji
	const group_box = document.querySelector(".group-box");

	ask_group_box_title &&
		(ask_group_box_title.onclick = function () {
			const content = this.nextElementSibling;
			ask_group.style.borderBottom = "1px solid white";

			if (content.style.maxHeight) {
				content.style.maxHeight = null;
				group_box.style.borderTop = "none";
			} else {
				content.style.maxHeight = content.scrollHeight + "px";
				group_box.style.borderTop = "1px solid white";
			}
		});

	//klik van klikabilnog naslova gasi visinu elementa
	document.body.addEventListener("click", (e) => {
		if (e.target != ask_group_box_title) {
			group_box && (group_box.style.maxHeight = null);
		}
	});

	new RemoveAutoFill(document.querySelectorAll("form"));
	cleanHotelCardStyles();

	// Header search
	if (document.querySelector("#header")) {
		new Search(document.querySelector(".right-header")).init();
		new Search(document.querySelector(".mobile-header")).init();
	}

	//popup form
	const popupButtons = document.querySelectorAll("#popup_form_button");
	if (popupButtons) {
		popupButtons.forEach((btn) => {
			new PopupForm(btn).init();
		});
	}

	//Deo koda koji omogucava da za svaki uredjaj viewport bude u visini mobilnog uredjaja koji korisnik koristi
	let vh = window.innerHeight * 0.01;
	// Then we set the value in the --vh custom property to the root of the document
	document.documentElement.style.setProperty("--vh", `${vh}px`);

	function toArray(collection) {
		return Array.prototype.slice.call(collection);
	}

	function noScroll(event) {
		if (event.type === "focus") {
			document.body.classList.add("no-scroll");
		} else if (event.type === "blur") {
			document.body.classList.remove("no-scroll");
		}
	}

	var inputs = toArray(document.querySelectorAll("input"));

	inputs.forEach(function (input) {
		input.addEventListener("focus", noScroll, false);
		input.addEventListener("blur", noScroll, false);
	});

	scrollCTA(document.querySelector(".send-query"));
	
});

function scrollCTA(cta, callback = false) {
	const heroEl = document.querySelector('#hero'),
		heroElHeight = heroEl && heroEl.offsetHeight || 400;

	if (window.scrollY >= heroElHeight) {
		cta.classList.add("show");
	} else {
		cta.classList.remove("show");
	}

	if (callback) {
		callback(cta);
	}

	window.requestAnimationFrame(() => {
		scrollCTA(cta, callback);
	});
}
